import React from 'react';

class Carousel extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.images = props.images
    this.className = props.className
    this.altText = props.altText

    this.state = {
      active: 0,
      max: this.images.length
    }
  }

  handlePrev(e) {
    e.preventDefault()

    let state = this.state
    state.active = state.active - 1
    if (state.active < 0) state.active = state.max - 1

    this.setState(state)

    return false;
  }

  handleNext(e) {
    e.preventDefault()

    let state = this.state
    state.active = state.active + 1
    if (state.active >= this.state.max) state.active = 0

    this.setState(state)

    return false;
  }

  render() {
    return (
      <div className={this.className}>
        <div className="carousel slide" data-ride="">
          <div className="carousel-inner">

            {this.images.map((item, idx) => (

              <div className={`${idx == this.state.active ? 'active' : ''} carousel-item`} key={idx} ref={idx}>
                <img className="d-block w-100 thumb" src={`https://content.grondwerkendierckx.be${item.imageURL}`} alt={`${this.altText} ${item.alttext}`} />
              </div>

            ))}

          </div>
          <a className="carousel-control-prev" href="#" role="button" data-slide="prev" onClick={(e) => this.handlePrev(e)}>
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="sr-only">Volgende</span>
          </a>
          <a className="carousel-control-next" href="#" role="button" data-slide="next" onClick={(e) => this.handleNext(e)}>
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="sr-only">Vorige</span>
          </a>
        </div>
      </div>
    )
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel/index.jsx